/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link as ReactLink } from 'wouter';

import * as AppPropTypes from '../../lib/PropTypes';
import Label from './Label';

const propTypes = {
    href: PropTypes.string,
    external: PropTypes.bool,
    target: PropTypes.string,
    children: AppPropTypes.label,
    rel: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    href: '',
    external: false,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: null,
    disabled: false,
    children: null,
    className: null,
};

const Link = ({
    href,
    external,
    children,
    target,
    onClick,
    rel,
    className,
    disabled,
    ...props
}) => {
    const onClickScroll = useCallback(
        (e) => {
            if (onClick !== null) {
                onClick(e);
            }
        },
        [onClick],
    );

    if (disabled) {
        return (
            <div className={className} {...props}>
                {children !== null ? <Label>{children}</Label> : null}
            </div>
        );
    }

    return external ? (
        <a className={className} href={href} target={target} rel={rel} {...props}>
            {children !== null ? <Label>{children}</Label> : null}
        </a>
    ) : (
        <ReactLink className={className} to={href} {...props} onClick={onClickScroll}>
            {children !== null ? <Label>{children}</Label> : null}
        </ReactLink>
    );
};
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export default Link;
